import React from "react";
import { Image, Table } from "react-bootstrap";
import formatPrice from "../../helpers/formatPrice";

export default function ColorsList({
  colors,
  columns,
  t,
  canModify,
  sortArrow,
  onSort,
  onRowClick,
  getMillingNames,
  onImageClick,
  tableContainerRef
}) {
  return (
    <div
      className="table-responsive"
      style={{ maxHeight: "80vh", overflowY: "auto" }}
      ref={tableContainerRef}
    >
      <Table bordered hover responsive>
        <thead
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1,
            backgroundColor: "#fff"
          }}
        >
          <tr>
            {columns.map(([key, label], index) => (
              <th
                key={index}
                onClick={key ? () => onSort(key) : undefined}
                style={{
                  cursor: key ? "pointer" : "default",
                  userSelect: "none",
                  whiteSpace: "nowrap"
                }}
              >
                {t(label)}
                {key ? sortArrow(key) : ""}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {colors.map((color) => (
            <tr
              key={color.colorId}
              onClick={() => onRowClick(color)}
              style={{
                cursor: canModify ? "pointer" : "default",
                backgroundColor: canModify ? "#f9f9f9" : "transparent"
              }}
            >
              <td>{color.colorId}</td>
              <td>
                <Image
                  src={`data:${color.imageContentType || "image/jpeg"};base64,${color.imageDataReduced}`}
                  loading="lazy"
                  alt={color.name}
                  style={{
                    width: 100,
                    height: 100,
                    objectFit: "cover",
                    cursor: "pointer",
                    boxShadow: "3px 5px 5px rgba(0,0,0,.3)"
                  }}
                  onClick={(event) => {
                    event.stopPropagation();
                    onImageClick(color);
                  }}
                />
              </td>
              <td>{t(color.name)}</td>
              <td>{color.dimension}</td>
              <td>{color.materialType}</td>
              <td>{color.active ? t("available") : t("notAvailable")}</td>
              <td>
                {color.materialType === "MDF"
                  ? color.painted
                    ? t("painted")
                    : t("notPainted")
                  : "-"}
              </td>
              <td>{color.rotable ? t("rotatable") : t("notRotatable")}</td>
              <td>
                {color.splitDimension ? t("splittable") : t("notSplittable")}
              </td>
              <td>{color.splitDimension || t("none")}</td>
              <td>{color.groupName}</td>
              <td>{formatPrice(color.price)}</td>
              <td>{getMillingNames(color.millingAssignments).join(", ")}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
